import classNames from 'classnames'
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { requestZoom } from '../../../store/map/map.actions'
import { selectMapMaxZoom, selectMapZoom } from '../../../store/map/map.selectors'
import { withOnlyGE } from '../../Device'
import T from '../../i18n/T'
import SVGIcon from '../../svg/SVGIcon'
import { useAction } from '../../utils/react-redux'
import { MAP_ZOOM_MIN, MAP_ZOOM_STEP } from '../map.constants'
import useTooltip from './useTooltip'
import s from './ZoomButtons.less'

const ZoomButton = ({ onClick, icon, className, label, ...otherProps }) => {
  const { tooltip, mouseListeners } = useTooltip({ ge: true })

  return (
    <div className={s.root}>
      <button
        {...otherProps}
        className={classNames(s.ZoomButton, className)}
        type="button"
        onClick={onClick}
        {...mouseListeners}
      >
        <SVGIcon icon={icon} />
      </button>
      <span className={classNames(s.tooltip, tooltip && 'active')}>
        <T id={`map.tools.zoom-${label}.tooltip`} />
      </span>
    </div>
  )
}

const ZoomInButton = props => (
  <ZoomButton {...props} icon={'plus'} aria-label="Zoom in" label={'in'} className={s.ZoomInButton} />
)

const ZoomOutButton = props => (
  <ZoomButton {...props} icon={'minus'} aria-label="Zoom out" label={'out'} className={s.ZoomOutButton} />
)

export const ZoomButtons = () => {
  const execRequestZoom = useAction(requestZoom)
  const zoomFromStore = useSelector(selectMapZoom)
  const maxZoom = useSelector(selectMapMaxZoom)
  // The state zoom exists because the store value is updated when animation finished
  // With the state zoom user can click several times during the animation
  const [zoom, setZoom] = useState()

  useEffect(() => {
    setZoom(zoomFromStore)
  }, [zoomFromStore])

  const updateZoom = useCallback(
    delta => {
      let targetZoom = zoom + delta
      if (targetZoom > maxZoom) targetZoom = maxZoom
      if (targetZoom < MAP_ZOOM_MIN) targetZoom = MAP_ZOOM_MIN

      execRequestZoom({ zoom: targetZoom })
      setZoom(targetZoom)
    },
    [zoom, maxZoom]
  )

  return (
    <div className={s.ZoomButtons}>
      <ZoomInButton onClick={() => updateZoom(MAP_ZOOM_STEP)} />
      <ZoomOutButton onClick={() => updateZoom(-MAP_ZOOM_STEP)} />
    </div>
  )
}

export default withOnlyGE(ZoomButtons)
